export default {
  computed: {
    canManageEmployees() { return this.$store.state.employees.canManageEmployees === true; },
  },
  methods: {
    async ensureEmployeeWriteAccess() {
      await this.$store.dispatch('employees/refreshPermissions');
      return this.canManageEmployees;
    },
  },
};
